import { useRef, useState } from 'preact/hooks';
import { RuzcalFormQuestionAnswer, RuzcalFormQuestionAnswerInputType } from './types';
import { IcoGripper, IcoTrash } from '@components/icons';
import { Button } from '@components/buttons';

interface Props {
  answer: RuzcalFormQuestionAnswer;
  draggable: boolean;
  type: RuzcalFormQuestionAnswerInputType;
  onChange: (updates: Partial<RuzcalFormQuestionAnswer>) => void;
}

export function FormQuestionAnswer({ answer, draggable, type, onChange }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div class="group mb-2">
      <div class="flex items-center relative mb-1" onClick={() => inputRef.current?.focus()}>
        <span
          class={`invisible ${draggable ? 'group-hover:visible' : ''} text-gray-400 cursor-move`}
          draggable={draggable}
        >
          <IcoGripper />
        </span>
        {(type === 'radio' || type === 'checkbox') && (
          <input type={type} class="ml-1 mr-2 h-5 w-5 border-gray-500" tabIndex={-1} />
        )}
        <input
          ref={inputRef}
          type="text"
          class="block grow md:pr-16 sm:text-sm border-transparent group-hover:border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
          value={answer.title}
          placeholder="Add new option"
          maxLength={2048}
          onInput={(e: any) => onChange({ title: e.target.value })}
          onBlur={() => setIsEditing(isEditing)}
        />

        <div
          class={`${
            isEditing ? '' : 'invisible'
          } group-hover:visible group-focus:visible absolute inset-y-0 right-8 pr-1 flex items-center`}
        >
          {
            <Button
              type="button"
              tabIndex={-1}
              class="hover:bg-zinc-100 p-2 rounded-sm"
              onClick={() => onChange({ deleted: true })}
            >
              <IcoTrash class="w-4 h-4 opacity-75" />
            </Button>
          }
        </div>
      </div>
    </div>
  );
}
